import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from "../../../config";
import { useNavigate } from 'react-router-dom';
import PermissionSelector from './PermissionSelector';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./CreateUserDashboard.css";

function CreateUserAcc({ editUser, closeForm, refresh }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    role: "",
    permissions: {}
  });
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (editUser && editUser._id) {
      setForm({
        name: editUser.name,
        email: editUser.email,
        password: "",
        role: editUser.role,
        permissions: editUser.permissions || {}
      });
    } else {
      setForm({
        name: "",
        email: "",
        password: "",
        role: "",
        permissions: {}
      });
    }
    // eslint-disable-next-line
  }, [editUser && editUser._id]);

  const roles = [
    { name: "admin" },
    { name: "hr" },
    { name: "accountant" },
    { name: "manager" }
  ];

  function handleFieldChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const method = editUser && editUser._id ? "put" : "post";
    const url = editUser && editUser._id
      ? `${API_URL}/api/users/update/${editUser._id}`
      : `${API_URL}/api/users/create`;
    const payload = { ...form };

    if (!payload.password) delete payload.password;
    if (editUser && !editUser._id) {
      alert('Edit mode: user ID missing!');
      return;
    }
    try {
      await axios[method](url, payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });

      alert(editUser ? "User updated!" : "User created!");
      if (typeof closeForm === 'function') closeForm();
      if (typeof refresh === 'function') refresh();
    } catch (err) {
      if (err.response) {
        alert('Backend error: ' + (err.response.data.msg || JSON.stringify(err.response.data)));
      } else if (err.request) {
        alert('Network error, no backend response');
      } else {
        alert('Request setup error: ' + err.message);
      }
    }
  }

  return (
    <div className="container mt-3 mb-3 cu-form-shell">
      <button
        className="btn btn-outline-secondary mb-3 cu-back-btn"
        onClick={() => navigate(-1)}
      >
        Back
      </button>

      <div className="card shadow rounded-3 border-0 cu-form-card">
        <div
          className="card-header text-white d-flex justify-content-between align-items-center cu-form-head"
        >
          <h4 className="mb-0">{editUser && editUser._id ? "Edit User Account" : "Create New User"}</h4>
        </div>

        <form className="card-body cu-form-body" onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Full Name</label>
              <input name="name" className="form-control cu-field" placeholder="Full Name" value={form.name} onChange={handleFieldChange} required />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Email</label>
              <input name="email" className="form-control cu-field" placeholder="Email" value={form.email} onChange={handleFieldChange} required />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Password</label>
              <div className="input-group">
                <input 
                  name="password" 
                  type={showPassword ? "text" : "password"} 
                  className="form-control cu-field" 
                  placeholder={editUser ? "New Password (optional)" : "Password"} 
                  value={form.password} 
                  onChange={handleFieldChange} 
                  required={!editUser} 
                />
                <button 
                  type="button" 
                  className="btn btn-outline-secondary" 
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ borderLeft: 0, backgroundColor: "#fff" }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Role</label>
              <select name="role" className="form-select cu-field" value={form.role} onChange={e => setForm(f => ({ ...f, role: e.target.value, permissions: {} }))} required>
                <option value="">Select Role</option>
                {roles.map((role, i) => (<option key={i} value={role.name}>{role.name}</option>))}
              </select>
            </div>
          </div>

          <PermissionSelector
            permissions={form.permissions}
            setPermissions={(perms) =>
              setForm((f) => ({ ...f, permissions: perms }))
            }
            role={form.role}
          />

          <div className="d-flex justify-content-end cu-submit-wrap">
            <button
              type="submit"
              className="btn px-4 shadow cu-submit-btn"
            >
              {editUser && editUser._id ? "Update User" : "Create User"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateUserAcc;
